module.exports = __webpack_public_path__ + "img/netherlands.0b607386.png";